import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Получен [N] уровень на Арене" — sent by the backend's
 * BattlePassManager::syncUser() on every Battle Pass level-up. Subject is
 * the recipient themselves (see LevelUpBlueprint's docblock); links to the
 * recipient's own Arena tab, where the Battle Pass bar with the freshly
 * unlocked rewards lives.
 */
export default class LevelUpNotification extends Notification {
  icon() {
    return 'fas fa-medal';
  }
  href() {
    const user = app.session.user;
    return user ? app.route('user.arena', {
      username: user.username()
    }) : '#';
  }
  content() {
    var _content$level;
    const content = this.attrs.notification.content() || {};
    return app.translator.trans('forumaker-arena.forum.notifications.level_up_text', {
      level: String((_content$level = content.level) != null ? _content$level : '')
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/LevelUpNotification', LevelUpNotification);